export enum INSTALLATION_TYPE {
  'update' = 'update',
  'store' = 'store',
  'individual' = 'individual',
}

export function isUpdating(installationTpe: INSTALLATION_TYPE): boolean {
  return installationTpe === INSTALLATION_TYPE.update;
}

export function isCreating(installationTpe: INSTALLATION_TYPE): boolean {
  return installationTpe === INSTALLATION_TYPE.store;
}

export function isIndividual(installationTpe: INSTALLATION_TYPE): boolean {
  return installationTpe === INSTALLATION_TYPE.individual;
}

export function getExtendedSerialNumber(serialNumber: string): string {
  return `900333.014-${serialNumber}`;
}
